<template>
    <div>
        <div class="row">
            <!-- Left Side -->
            <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Select Patient: </span>
                    </div>

                    <div class="col-md-7">
                        <AsyncSelect
                            placeholder="Patient Name, ID, Mobile No"
                            v-model="patient"
                            :api-service="fetchContactProfiles"
                            :additional-query="additionalQuery"
                            :format-label="formatPatientLabel"
                        />
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Patient ID: </span>
                    </div>

                    <div class="col-md-7">
                        <span> <strong>{{ patientId }}</strong> </span>
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Patient Phone No: </span>
                    </div>

                    <div class="col-md-7">
                        <span> <strong> {{patientMobile && patientMobile.value}} </strong> </span>
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Select Admission info: </span>
                    </div>

                    <div class="col-md-7">
                        <div>
                            <v-select
                                placeholder="Select Admission Info"
                                label="text"
                                :options="registrationList"
                                v-model="formData.ipd_register_id"
                                :reduce="text => text.id"
                            />
                        </div>
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Ward / Bed / Cabin: </span>
                    </div>

                    <div class="col-md-7">
                    <span> <strong>
                        {{ selectedRegisterInfo && selectedRegisterInfo.service_resource.name }}
                    </strong> </span>
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Consultant / Doctor: </span>
                    </div>

                    <div class="col-md-7">
                    <span> <strong>
                        {{ selectedRegisterInfo && selectedRegisterInfo.human_resource.name }}
                    </strong> </span>
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span>Select Referrer:</span>
                    </div>

                    <div class="col-md-7">
                        <div>
                            <AsyncSelect
                                placeholder="Select Referrer"
                                v-model="formData.referrer_id"
                                :api-service="fetchContactProfiles"
                                :additional-query="{ type: 'agent' }"
                                :format-label="formatPatientLabel"
                                :reduce="referrer => referrer.id"
                            />
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-md-2">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="openPatientAddModal"
                >
                    New Patient
              </button>
            </div>
            <!-- Right Side -->
            <div class="col-12 col-sm-5 col-md-5 col-lg-5">

                <div class="row h-40 mb-5">

                    <div class="col-md-7">
                        <input
                            v-model="patientSerialNo"
                            name="serial"
                            type="number"
                            class="form-control"
                            placeholder="Patient Id"
                            @keyup="searchPatientById"
                        />
                    </div>

                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Invoice Date: </span>
                    </div>

                    <div class="col-md-7">
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.date"
                        >
                    </div>
                </div>

                <div class="row h-40">
                    <div class="col-md-5 d-flex align-items-center">
                        <span> Ship from (Warehouse): </span>
                    </div>

                    <div class="col-md-7">
                        <v-select
                            placeholder="Select Warehouse Location"
                            v-model="formData.location_id"
                            :options="locations"
                            label="text"
                            :reduce="text => text.id"
                        />
                    </div>
                </div>

            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 col-md-10">
              <ProductSearch
                  @onSelectNote="onSelectNote"
                  :formData="formData"
                  ref="productField"
              />
            </div>
            <div class="col-12 col-md-2">
                <input
                    ref="quantityField"
                    id="quantity"
                    name="quantity"
                    type="number"
                    class="form-control"
                    v-model="formData.quantity"
                    placeholder="quantity"
                    @keydown.enter="handleProductSelection"
                />
            </div>
        </div>

        <AddPatientModal
            v-if="$store.state.isModalOpenTwo"
            :doctors="doctors"
            @onCreateProfile="onCreateProfile"
        />

        <Loader v-if="isLoader" />

    </div>
</template>

<script setup>
import {computed, inject, onMounted, ref, watch, reactive, nextTick} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import { useStore } from 'vuex';
import handlePurchase from '@/services/modules/purchase'
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleContact from '@/services/modules/contact'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleHospitalBilling from "@/services/modules/hospital/billing";
import AddPatientModal from '@/components/molecule/company/hospital/AddPatientModal'
import useDate from "@/services/utils/day";
import handleHospital from '@/services/modules/hospital'
import Loader from "@/components/atom/LoaderComponent";
import ProductSearch from '@/components/atom/hospital/pharmacy-bill-v3/ProductSearch.vue';

const props = defineProps({
  addNewItem: {
    type: Function
  },
  tableItems: {
    type: Array
  },
  additionalProductQuery: {
    type: Object
  }
})

const $route = useRoute();
const $router = useRouter();
const $store = useStore();
const date = useDate();
const patient = ref(null)
const userInfo = ref(null);
const isLoader = ref(false);
const patientSerialNo = ref(null);
const quantityField = ref(null)
const productField = ref(null)
const companyId = $route.params.companyId
const companyQuery = `?company_id=${companyId}`;
const selectedData = ref({});
const formData = inject('formData');
const showError = inject("showError")
let loader =ref(false);
let locations = ref([]);
const productId = ref(null);
const registrationList = ref([]);
const additionalQuery = {
    type: "patient"
}
const doctors = reactive([]);

const { fetchProductById } = handlePurchase()
const { fetchBusinessLocationsList } = handleBusinessesLocations()
const { fetchContactProfiles, fetchSingleContactProfile } = handleContact()
const { fetchIpdRegisterList } = handleHospitalBilling()
const { formatPatientLabel } = useAsyncDropdownHelper()
const { fetchPatientDetailsBySerial } = handleHospital()

const selectedRegisterInfo = computed(() => {
    if (formData.value.ipd_register_id) {
        return registrationList.value.find(registration => registration.id === formData.value.ipd_register_id)
    }
    return null
})

const patientMobile = computed(() => {
    if (selectedData.value && selectedData.value.profile_items && selectedData.value.profile_items.length) {
        return selectedData.value.profile_items.find(item => item.field === 'mobile_no')
    }
    return null
})

const patientId = computed(() => {
    if (
        selectedData.value &&
        selectedData.value.company_roles &&
        selectedData.value.company_roles.length &&
        selectedData.value.company_roles[0].pivot
    ) {
        return selectedData.value.company_roles[0].pivot.serial_no
    }
    return null
})

const onSelectNote = (note) => {
   productId.value = note.id
}

const openPatientAddModal = () => {
    const query = `?company_id=${companyId}&type=doctor`
    fetchContactProfiles(query).then((res) => {
        if(res.status) doctors.push(...res.data)
    }).then(() => {
        $store.state.isModalOpenTwo = true
    })
}

const searchPatientById = async () => {
    if(!patientSerialNo.value) return;
    userInfo.value = null
    isLoader.value = true;
    const query = `?company_id=${companyId}`;

    await fetchPatientDetailsBySerial(query, patientSerialNo.value)
        .then((res) => {
            if (!res.status) {
                userInfo.value = null
                patient.value = null
                return showError(res.message)
            }
            
            userInfo.value = res.data
            patient.value = {
                id: userInfo.value.id,
                name: userInfo.value.full_name
            }
        })
    
    isLoader.value = false;
}

const onCreateProfile = (profileInfo) => {
    patient.value = profileInfo;
    patient.value.name = profileInfo.full_name
}

const focusProductSelect = () => {
  if (productField.value) {
    productField.value.clearSearch();
  }
}

const handleProductSelection = async () => {
    if (! productId.value) {
        showError("Please select product first!");
        focusProductSelect()
        return;
    }

    if (!formData.value.quantity) {
        showError("Please enter valid quantity first!");
        return;
    }

    let quantity = Number(formData.value.quantity)

    if (! Number.isInteger(quantity)) {
        showError("The quantity can only be a number");
        formData.value.quantity = parseInt(formData.value.quantity)
        return;
    }

    const productResp = await fetchProductById(productId.value, `${companyQuery}&location_id=${formData.value.location_id}`);

    if (!productResp.data) {
        showError("Product not found");
        focusProductSelect()
        return;
    }

    const selected = productResp.data;
    let alreadyExist = false;

    let product = {
        name: selected.name
    }

    props.tableItems.map((item) => {
      if(item.productId === selected.id)
      {
        alreadyExist = true;
        item.quantity += quantity;
      }
    })

    if(! alreadyExist) {
      props.tableItems.push({
        product_id: selected.id,
        name: selected.name,
        stock_in_hand: selected.stock_in_hand,
        description: '',
        quantity: quantity,
        rate:  selected.sales_price,
        purchase_rate:  selected.purchase_rate,
        discount: 0,
        vat: 0,
        sub_total: 0,
        discount_amount: 0,
        discount_percent: 0,
        vat_amount: 0,
        total: 0,
        isEdit: false,
        batch_details: [],
        product: product
      })
    }

    formData.value.quantity = null;
    productId.value = null;
    focusProductSelect()
}

const generateDateAndInvoice = () => {
    formData.value.date = date.currentDate();
}

const resetData = () => {
    generateDateAndInvoice();
    patient.value = null;
    productId.value = null;
    patientSerialNo.value = null;
    formData.value.location_id = locations.value[0].id
    productField.value.clear();
}

onMounted(async () => {
    generateDateAndInvoice();
    const locationQuery = `${companyQuery}&location_type=fg_warehouse`;
    fetchBusinessLocationsList(locationQuery).then(res=> {
      if(res.data) {
          locations.value = res.data
          formData.value.location_id = res.data[0].id
      }
    })
})

watch(patient, () => {
    const patientQuery = companyQuery + '&type=patient';
    formData.value.contact_profile_id = null;
    selectedData.value = null;
    registrationList.value = [];
    if (!patient.value) {
       return
    }
    formData.value.contact_profile_id = patient.value.id;
    const ipdRegisterRes = fetchIpdRegisterList(`${companyQuery}&contact_profile_id=${patient.value.id}`)
    fetchSingleContactProfile(patient.value.id, patientQuery).then(res => {
      if (res.data) {
        selectedData.value = formData.value.contact = res.data;
      }
    })
    ipdRegisterRes.then(res => {
      if(res.data) registrationList.value = res.data
    })
})

watch(productId, () => {
    if(! productId.value) {
        return;
    }

    if (quantityField.value) {
        quantityField.value.focus();
    }
})

watch(selectedRegisterInfo, (newValue) => {
    if (newValue) {
        formData.value.service_resource_id = "human_resource" in newValue ? newValue.human_resource.id : null
    }
})

defineExpose({
    resetData
})

</script>

<style>
.select label{
    font-size: 14px;
}
.h-40{
    height: 40px;
    align-items: center;
}
</style>